import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import isNil from 'lodash/isNil';
import { createHook, createSelector } from 'react-sweet-state';
import { store } from '../../main';
/*
 * When there is an error in any part of UI modifications
 * we need to ensure that fields from the Jira view are not blocked by reacting on an error here.
 * e.g. GIC fields will not be blocked anymore when error occurs in one of the decorators.
 */
export var selectFieldIsProcessing = createSelector(function (state) {
  return state.registeredFields;
}, function (state) {
  return state.error;
}, function (_, fieldId) {
  return fieldId;
}, function (registeredChangesMap, error, fieldId) {
  if (error) {
    return {
      isBusy: false,
      appsIds: []
    };
  }
  var appsIds = Object.entries(registeredChangesMap).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      _ = _ref2[0],
      registeredFields = _ref2[1];
    return !isNil(registeredFields) && Object.values(registeredFields).flat().includes(fieldId);
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      appId = _ref4[0];
    return appId;
  });
  return {
    isBusy: appsIds.length > 0,
    appsIds: appsIds
  };
});
export var useFieldIsProcessing = createHook(store, {
  selector: selectFieldIsProcessing
});